<template>
    <div>
        <iframe :id="id ? id : 'pdf_iframe'"
                :src="src"
                :style="!!height ? !!width ? ('height:' + height + '; width:' + width + ';') : ('height:' + height + ';') : !!width ? ('width:' + width + ';') : 'height=\'85vh\' width=\'100%\''"
                frameborder="0"
                @load="emitLoaded">
        </iframe>
    </div>
</template>

<script>

export default {
    name: "PdfPreviewer",
    components: {

    },
    props: {
        src: {
            type: String,
            required: false
        },
        height: {
            type: String,
            required: false
        },
        width: {
            type: String,
            required: false
        },
        id: {
            type: String,
            required: false,
        }
    },
    data() {
        return {
            template: {},
            status: 'loading',
        }
    },
    mounted() {

    },
    methods: {
        emitLoaded(e) {
            this.$emit('loaded');
        }
    },
    setup() {
        return {

        }
    }
}
</script>
